import { createCn } from "cn/config";

/**
 * Class merger (clsx + tailwind-merge semantics). Crew's custom theme names are
 * registered so they merge correctly: `cn("text-ink text-title")` keeps both,
 * `cn("shadow-sm shadow-card")` keeps only `shadow-card`.
 */
export const cn = createCn({
  extend: {
    theme: {
      text: ["2xs", "meta", "nav", "body", "lead", "question", "title", "page", "display"],
      shadow: ["card", "ring", "nav", "composer", "outline", "selected", "panel"],
      radius: ["nav", "well", "tile", "panel"],
    },
  },
});
